import { useMemo } from "react";
import { useGame, usePublisherGameAsDesigner } from "@seabrookstudios/pitch2table";
import { Path } from "../Path";
import { useRegisterRelatedDestinations } from "../core/RelatedDestinations";

/**
 * Spike: register related destinations for an inbox message in the top bar.
 * Filed messages expose Inbox → publisher → submission → game.
 *
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").InboundEmail} props.message
 */
export const InboxRelatedDestinations = ({ message }) => {
  const { data: publisherGame } = usePublisherGameAsDesigner(message.publisherGameId || null);
  const { data: game } = useGame(publisherGame?.gameId || null);

  const destinations = useMemo(() => {
    /** @type {import("../core/RelatedDestinations").RelatedDestination[]} */
    const items = [{ id: "inbox", label: "Inbox", to: Path.inbox().none() }];

    if (!publisherGame) {
      return items;
    }

    items.push({
      id: "publisher",
      label: publisherGame.publisherName || "Publisher",
      to: Path.publisher(publisherGame.publisherId).link(),
    });
    items.push({
      id: "submission",
      label: "Submission",
      to: Path.game(publisherGame.gameId).publisher(publisherGame.publisherId),
    });

    if (game) {
      items.push({
        id: "game",
        label: game.name || "Game",
        to: Path.game(game.id).link(),
      });
    }

    return items;
  }, [publisherGame, game]);

  useRegisterRelatedDestinations(destinations);

  return null;
};
